import { render } from "./EditResendTemplate.vue?vue&type=template&id=af14536a&scoped=true"
import script from "./EditResendTemplate.vue?vue&type=script&lang=js"
export * from "./EditResendTemplate.vue?vue&type=script&lang=js"

import "./EditResendTemplate.vue?vue&type=style&index=0&id=af14536a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af14536a"]])

export default __exports__